import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  const getDirectImageUrl = (url) => {
    if (!url || typeof url !== 'string') return url;

    const isExternal = url.startsWith('http') || url.startsWith('//');

    // Resolve any relative asset paths (e.g. ../../../assets/...) to absolute paths for local assets only
    if (!isExternal && url.includes('assets/')) {
      const idx = url.indexOf('assets/');
      return '/' + url.substring(idx);
    }
    
    // Check if it's a Google Drive or Google Docs link
    if (url.includes('drive.google.com') || url.includes('docs.google.com')) {
      // Robust regex to extract the file ID from various Drive URL patterns
      const driveMatch = url.match(/(?:\/d\/|id=)([\w-]{25,})/);
      
      if (driveMatch && driveMatch[1]) {
        // use export=view to ensure it renders as an image
        return `https://drive.google.com/uc?export=view&id=${driveMatch[1]}`;
      }
    }
    
    return url;
  };

  const processedSrc = getDirectImageUrl(src);

  const isGoogleDrive = src && (src.includes('drive.google.com') || src.includes('docs.google.com') || src.includes('googleusercontent.com'));

  return (
    <img
      src={processedSrc}
      alt={alt}
      className={className}
      {...(isGoogleDrive ? { referrerPolicy: "no-referrer" } : {})}
      onError={(e) => {
        // Fallback to a placeholder if the image fails to load
        if (e.target.src !== "/assets/images/no_image.png") {
           e.target.src = "/assets/images/no_image.png";
        }
      }}
      loading="lazy"
      decoding="async"
      {...props}
    />
  );
}

export default Image;
